/**
 * After Play, before the first note: how long a graded repertoire piece
 * waits (cursor flashing, metronome running) before it pauses itself. It
 * runs on every Play, a resume after a pause included. Once a note has been
 * played the piece pauses after 10 s without one, as before.
 */
export const REPERTOIRE_START_WAIT_MS = 20000;
